import { BulkEditSubItem, SubItem } from '../../items/types/sub-item.types';

import { Item } from '../../items/types/item.types';
import create from 'zustand';

export enum ActionType {
   none,
   adding,
   editing,
   editingItem,
   bulkAdding,
   bulkEditing,
}

type ActionState = {
   actionType: ActionType;
   parentItem?: Item;
   editRowData?: SubItem;
   bulkEditRowData?: BulkEditSubItem;
};

export const useActionState = create<ActionState>(() => ({
   actionType: ActionType.none,
}));
